import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { MetricValueKind, MetricReportingPeriodType } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultMetricReportingPeriod',
  props: {
  value: {
    type: String as () => MetricReportingPeriodType,
    default: () => {},
  },
  type: {
    type: String as () => MetricValueKind,
    default: () => {},
  },
  editable: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;



const isMonthlyDisabled = computed(() => {
  const restrictedTypes = [
    MetricValueKind.Binary,
    MetricValueKind.Select,
    MetricValueKind.SingleSelect,
  ]
  return restrictedTypes.includes(props.type)
})

return { __sfc: true,props, isMonthlyDisabled, MetricReportingPeriodType }
}

})